import { fromPromise } from 'rxjs/observable/fromPromise';

import { map, mergeMap, switchMap } from 'rxjs/operators';

import { getWorkspaces as getWorkspacesAction, changeWorkspaces } from './actions';

import { fetchWorkspaces, updateSpaces } from '../../../api/workspace/service';

export const $INFR_FORMAT_WORKSPACES = (workspaces = []) =>
  workspaces.reduce((obj, ws) => ({ ...obj, [ws.workspaceId]: ws }), {});

export const INFR_GET_WORKSPACES = (action$) =>
  action$.pipe(
    mergeMap(() =>
      fromPromise(fetchWorkspaces()).pipe(
        map(({ workspaces }) => $INFR_FORMAT_WORKSPACES(workspaces)),
        map((workspaces) => changeWorkspaces(workspaces))
      )
    )
  );

export const INFR_UPDATE_WORKSPACES = (action$) =>
  action$.pipe(
    switchMap((action) =>
      fromPromise(updateSpaces(action.update)).pipe(map(() => getWorkspacesAction()))
    )
  );
